// AuthGuard.tsx
import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { navigate } from '@redwoodjs/router';

import { useAuthContext } from 'src/contexts/AuthProvider';
import { isPublicRoute } from 'src/contexts/AuthProvider/utils';
import { GuardProps } from 'src/types';

import { hasPermission, routePermissions } from '../permissions';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const location = useLocation();
    const { loading, isAuthenticated, user } = useAuthContext();
    const [currentLocation, setCurrentLocation] = useState(location.pathname);

    useEffect(() => {
        if (!isAuthenticated) {
            let redirect = `?redirectURI=${currentLocation}`;
            if (currentLocation === '/') {
                redirect = '';
            }
            navigate(`/login${redirect}`);
            return;
        }
    }, [isAuthenticated, currentLocation]);

    useEffect(() => {
        if (isPublicRoute(currentLocation) || loading) {
            return;
        }

        const requiredPermission = routePermissions[currentLocation];
        const userRolePermissions = user?.role?.permissions;

        if (
            requiredPermission &&
            user &&
            user.role &&
            !hasPermission(userRolePermissions, requiredPermission)
        ) {
            navigate('/unauthorized');
            return;
        }
    }, [currentLocation, loading, user]);

    return children;
};

export default AuthGuard;
